import { Component, Input, OnInit } from "@angular/core";
import { FormGroup, FormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";
import { ReactiveFormsModule } from "@angular/forms";
import { NgSelectModule } from "@ng-select/ng-select";

@Component({
  imports: [CommonModule, ReactiveFormsModule, NgSelectModule, FormsModule],
  selector: "hawk-address-form",
  templateUrl: "./address-form.component.html",
  styleUrls: ["./address-form.component.scss"],
  host: {
    class: "bm-fieldset",
  },
})
export class AddressFormComponent implements OnInit {
  @Input() formGroup: FormGroup;
  @Input() prefix: string = "";
  @Input() countries: any[] = [];

  public searchTerm: string = "";
  public _prefix: string = "";

  constructor() {}

  ngOnInit(): void {
    this._prefix = this.prefix;
    if (this.prefix && !this.prefix.endsWith("_")) this._prefix = this.prefix + "_";
  }
}
